<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
        <!--科服云动态详情-->
        <DynamicXqNei ></DynamicXqNei>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import DynamicXqNei from "./base/DynamicXq";
     export default {
        name: "Dynamicxq",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            DynamicXqNei
        }
    }
</script>

<style scoped>

</style>
